import { FC, Dispatch, SetStateAction } from 'react'

/* Utils */
import { CategoryActivityItem, IChartData, IFramework } from '../../../../../models'

/* Components */
import { HeroSectionWrapper } from '../../dashboard.styles'
import DashboardHeroEmpty from '../../components/DashboardHeroEmpty'
import DashboardHero from '../../components/DashboardHero'

interface Props {
  performanceScore: number
  performanceLastMonthChange: number | null
  chartLoading: boolean
  initialLoad: boolean
  chartData: IChartData[]
  noCategories: boolean
  handleCategoryClick: (category: string) => void
  lastUpdatePerformance: string
  unreadInsightsCount: number
  insightsCountLoading: boolean
  insightsData: any
  setHoveredCard: Dispatch<SetStateAction<string>>
  customFramework: IFramework | null
  categories: CategoryActivityItem[]
}

const HeroSection: FC<Props> = ({
  performanceScore,
  performanceLastMonthChange,
  chartLoading,
  initialLoad,
  chartData,
  noCategories,
  handleCategoryClick,
  lastUpdatePerformance,
  unreadInsightsCount,
  insightsCountLoading,
  insightsData,
  setHoveredCard,
  customFramework,
  categories
}) => (
  <HeroSectionWrapper>
    {initialLoad && noCategories ? (
      <DashboardHeroEmpty performanceScore={performanceScore} categories={categories} />
    ) : (
      <DashboardHero
        performanceScore={performanceScore}
        performanceLastMonthChange={performanceLastMonthChange}
        categories={categories}
        chartLoading={chartLoading}
        initialLoad={initialLoad}
        chartData={chartData}
        noCategories={noCategories}
        handleCategoryClick={handleCategoryClick}
        lastUpdatePerformance={lastUpdatePerformance}
        unreadInsightsCount={unreadInsightsCount}
        insightsCountLoading={insightsCountLoading}
        insightsData={insightsData}
        setHoveredCard={setHoveredCard}
        customFramework={customFramework}
      />
    )}
  </HeroSectionWrapper>
)

export default HeroSection
